import { TabList, TabListType } from './tab/tab-list';
import { StyledTabContainer, StyledTabs } from './tabs.styled';

interface TabsProps {
	children: React.ReactNode;
	tabLists: Array<TabListType | null>;
	isDraft?: boolean;
	basePath?: string;
	/** Rendered at the far end of the tab row, opposite the tabs themselves. */
	actions?: React.ReactNode;
}

export const Tabs: React.FC<TabsProps> = ({
	children,
	tabLists,
	isDraft = false,
	basePath,
	actions,
}: TabsProps) => {
	return (
		<StyledTabs>
			<TabList isDraft={isDraft} tabLists={tabLists} basePath={basePath} actions={actions} />
			<StyledTabContainer>{children}</StyledTabContainer>
		</StyledTabs>
	);
};
